import { Card, CardContent } from "../ui/card";

const About = () => (
  <section className="transition-opacity duration-300">
    <Card className="hover:shadow-lg transition-shadow duration-300">
      <CardContent className="p-8">
        <h2 className="text-3xl font-bold mb-6 text-[#57068C]">About Me</h2>

        {/* Title */}
        <h3 className="text-2xl font-semibold mb-4 text-gray-800">
          Advancing Mental Health Through Neuroscience, Psychedelic Research,
          and Compassionate Innovation
        </h3>

        {/* Introduction Paragraph */}
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          With a deep-rooted passion for mental health and neuroscience, I bring
          a unique blend of academic rigor, clinical experience, and
          programmatic leadership to the evolving field of psychedelic medicine.
          Having recently completed my Master's in Psychology at New York
          University—with a specialization in clinical neuroscience and
          psychopharmacology—I've devoted my research and professional efforts
          to exploring the therapeutic potential of psychedelic-assisted
          interventions for trauma and mood disorders.
        </p>

        {/* Expertise Paragraph */}
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          My graduate thesis, currently in progress for publication,
          investigates{" "}
          <strong>
            psilocybin-assisted therapy as a pharmacological intervention for
            depression and PTSD through its modulation of the Default Mode
            Network (DMN)
          </strong>
          . This work not only solidified my expertise in translational
          neuroscience, but also deepened my understanding of the intersection
          between cognitive science, neurobiology, and therapeutic application.
        </p>

        {/* Value Proposition */}
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          Beyond the lab, I've contributed to clinical operations at NYU's
          Steinhardt School and NOVA Southeastern University, where I supported
          multidisciplinary teams in delivering compassionate, evidence-based
          care. I also played a key role in the development of NYU's Collegiate
          Recovery Program, creating neuroscience-informed educational materials
          to support students recovering from substance use and mental health
          challenges—an initiative that reflects my commitment to stigma
          reduction and community-driven mental health education.
        </p>

        {/* Current Role and Specializations */}
        <div className="mb-6">
          <p className="text-gray-700 text-lg leading-relaxed mb-3">
            I specialize in:
          </p>
          <ul className="list-disc list-inside text-gray-700 text-lg leading-relaxed ml-4 space-y-2">
            <li>
              <strong>Designing and conducting clinical research</strong> on
              psychedelic interventions
            </li>
            <li>
              <strong>Translating complex neuroscience</strong> into accessible,
              educational content
            </li>
            <li>
              <strong>Statistical analysis</strong> using SPSS and R for
              experimental psychology
            </li>
            <li>
              <strong>Interdisciplinary collaboration</strong> with clinicians,
              educators, and researchers
            </li>
            <li>
              <strong>Mental health outreach and program development</strong>{" "}
              for mental wellness in university settings
            </li>
            <li>
              <strong>Critical review and synthesis</strong> of scientific
              literature in psychopharmacology
            </li>
          </ul>
        </div>

        {/* Passion and Commitment */}
        <p className="text-gray-700 text-lg leading-relaxed mb-6">
          What sets me apart is my ability to integrate academic insight with
          human-centered advocacy. I don't just study mental health—I help build
          the programs, create the content, and support the people that drive it
          forward. With bilingual fluency in English and Spanish and experience
          collaborating across disciplines, I bring cultural competence,
          adaptability, and a research-driven mindset to every opportunity.
        </p>

        {/* Closing Statement */}
        <p className="text-gray-700 text-lg leading-relaxed mb-4">
          I'm passionate about contributing to labs and organizations at the
          forefront of psychedelic science and integrative mental healthcare.
          Whether in a research, programmatic, or clinical support role, I aim
          to advance innovative, compassionate, and scientifically sound
          approaches to healing.
        </p>

        {/* Call to Action */}
        <p className="text-gray-800 text-lg font-semibold">
          Ready to bring my passion and enthusiasm to any job opportunity.
        </p>
      </CardContent>
    </Card>
  </section>
);

export default About;
